import axios from "axios"

const baseURL = process.env.REACT_APP_API_URL +"auth/"

const apiLogin = async (username, password) => {
  return await axios
    .post(baseURL+"signin", {
      email: username,
      password: password
    })
    .then((response) => {
      return response
    }).catch((e) => {
      return e.response.data
    })
}

const api_signUp = async (email, cnic) => {
  return axios
    .post(baseURL+"signup", {
      email: email,
      cnic: cnic
    })
    .then((response) => {
      return response
    }).catch((e) => {
      return e.response.data
    })

}

const api_forgetPassword = async (email) => {
  return axios
    .post(baseURL+"forget_password", {
      email: email
    })
    .then((response) => {
      return response
    }).catch((e) => {
      return e.response.data
    })
}

const validateSessionID = (session_id, email) => {


  return axios
    .post(baseURL+"verifySessionId", {
      session_id: session_id,
      email: email
    })
    .then((response) => {
      return response
    }).catch((e) => {
      return e.response.data
    })

}


export { apiLogin, api_signUp, api_forgetPassword, validateSessionID }